import { Injectable } from '@angular/core';
import { LocalStorageKeys, Module, UserSession } from '@models/index.model';
import { UtilsService } from '@services/index.service';

@Injectable({
  providedIn: 'root',
})
export class ModulesService {
  public constructor(private _utils: UtilsService) {}

  public setModulesToLocalStorage(userModules: Module[]) {
    let userSession: UserSession = this._utils.getLocalStorage(LocalStorageKeys.SESSION_KEY) as UserSession;
    if (!!userSession) {
      userSession['userModules'] = userModules;
      this._utils.setLocalStorage(LocalStorageKeys.SESSION_KEY, userSession);  
    }    
  }

  public getModulesFromLocalStorage(): Module[] {
    return (this._utils.getLocalStorage(LocalStorageKeys.SESSION_KEY) as UserSession)?.userModules;
  }

  public hasModule(moduleToCheck: Module): boolean {
    const userModules: Module[] = this.getModulesFromLocalStorage();
    if (!!userModules) {
      return userModules.includes(moduleToCheck);
    }
    return false;
  }

  public hasAllModules(...modulesToCheck: Module[]): boolean {
    return modulesToCheck && modulesToCheck.every(moduleWanted => this.hasModule(moduleWanted));
  }
}
